// @ts-nocheck

import { useEffect, useState } from 'react';
import type { ContactOptionMap } from './ContactsNotificationPreference';
import { Tr, Table, TableCaption, TBody, Th, THead } from '@mds/web-ui-table';
import { Text } from '@mds/web-ui-text';
import styles from './NotificationTable.module.scss';
import ConfigRuleRow from './NotificationTableRow';
import { IconAddCircle } from '@mds/web-ui-icons';
import { Link } from '@mds/web-ui-link';
import type { Role } from '../../models/Role';
import type {LoanDataFields} from '../../models/LoanDataFields';

interface NotificationTableProps {
  title: string;
  roleData: Role[];
  roleRules: Role[];
  loanType: string;
  contactOptionMap: ContactOptionMap;
  loanId?:string|null;
  loanDataFields?: LoanDataFields;
}

const NotificationTable: React.FC<NotificationTableProps> = ({
 title,
 roleData,
 roleRules,
 loanType,
 contactOptionMap,
 loanId,
 loanDataFields
}) => {
  const [showAddAlt, setShowAddAlt] = useState<boolean>(false);
  const [contactRules, setContactRules] = useState<Role[]>([]);
  const [selectedContacts, setSelectedContacts] = useState<Set<string>>(new Set());
  const [primaryField,setPrimaryField] = useState([]);
  const [altField,setAltField] = useState([]);


  useEffect(() => {
    const primaryRules = roleRules.filter((rule)=> rule.primary);
    const alternateRules = roleRules.filter(rule=>!rule.primary);

    const combinedPrimary = primaryRules.map((rules)=>{
      const specificValue = roleData.find((role)=>role.roleID === rules.roleID);
      if(specificValue){
        return {...rules,...specificValue}
      }else{
        return {...rules}
      }
    })
    const combinedAlt = alternateRules.map((rules)=>{
      const specificValue = roleData.find((role)=>role.roleID === rules.roleID);
      if(specificValue){
        if(specificValue?.user === null) {
          return {...rules, ...specificValue, showAlt: false}
        }
        return {...rules,...specificValue , showAlt: true}
      }else{
        if(specificValue?.user !== null){
          return {...rules,showAlt: true}
        }
      }
    })
    setPrimaryField(combinedPrimary);
    setAltField(combinedAlt);


  }, [roleRules,roleData]);
  useEffect(() => {
    if(altField.every(alt=>alt.showAlt)){
      setShowAddAlt(false)
    }else{
      setShowAddAlt(true)
    }
  }, [altField]);

  const handleAddAlt = () => {
    const alternateRole = altField.find(
      (role) => role.user === null && !role.showAlt,
    );
    const updatedAltField = altField.map((field)=>{
      if(field.roleID === alternateRole.roleID){
        return {...field,showAlt:true}
      }else{
        return field
      }
    })
  setAltField(updatedAltField);
  };

  const handleRemoveAlt = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const roleIdToRemove = e.currentTarget.id;
    const updatedAltField = altField.map((field)=>{

      if(field.roleID === +roleIdToRemove){
        return {...field,showAlt:false,user:null}
      }else{
        return field
      }
    })
    setAltField(updatedAltField)
  };

  const handleSelectContact = (roleID: string, contactID: string, previousContactID?: string) => {
    setSelectedContacts((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (previousContactID) {
        newSelected.delete(previousContactID);
      }
      newSelected.add(contactID);
      return newSelected;
    });
  };

  const renderConfigRuleRow = (
    role: Role,
    options: ContactOptionMap['primary' | 'alternate'],
  ) =>
  {
    if(role.showAlt || role.primary) {
      return <ConfigRuleRow
        roleData={roleData}
        options={options}
        role={role}
        key={role.roleID}
        handleRemoveAlt={!role.primary ? handleRemoveAlt : undefined}
        selectedContacts={selectedContacts}
        onSelectContact={handleSelectContact}
        selectedLoanType={loanType.startsWith('Delegate') ? '' : title}
        loanId={loanId}
        loanDataFields={loanDataFields}
      />
    }
  };
  return (
    <div>
      <Table className={styles.fullSizeTable}>
        <TableCaption
          className={styles.tableCaption}
          text={loanType.startsWith('Delegate') ? '' : title}
        />
        <THead>
          <Tr>
            <Th
              id="contactPriority"
              scope="col"
              text="Contact priority"
              width="15%"
            />
            <Th
              id="contactName"
              scope="col"
              text="Lender contact name"
              width="25%"
            />
            <Th id="contactEmail" scope="col" text="Email" width="25%" />
            <Th id="contactPhone" scope="col" text="Phone" width="25%" />
            <Th
              id="contactNotify"
              scope="col"
              text="Email notifications"
              width="15%"
            />
            {contactRules.length > 1 && (
              <Th id="removeRow" scope="col" text=" " width="5%" />
            )}
          </Tr>
        </THead>
        <TBody>
          {primaryField
            .map((rule) => renderConfigRuleRow(rule, contactOptionMap.primary))}
          {altField
            .map((rule) =>
              renderConfigRuleRow(rule, contactOptionMap.alternate),
            )}
        </TBody>
      </Table>

      <div>
        <Link
          onClick={showAddAlt ? handleAddAlt : undefined}
          className={`${styles.tableLink} ${!showAddAlt ? styles.disabledLink : ''}`}
          data-testid={`add-alt-${title}`}
        >
          <IconAddCircle
            aria-label="add"
            role="img"
            size="medium"
            className={styles.middle}
          />
          <Text textStyle="bodyLarge" className={styles.middle}>
            Alternate
          </Text>
        </Link>
      </div>
    </div>
  );
};

export default NotificationTable;
